// 异步路由文件，动态渲染的路由都渲染在layout下
import Layout from '../../layout/Index.vue' //导航
//import Layout from '@/views/portal/doorLayout.vue'
import { NotFound } from 'vue-common-laboratory' //404
const config = this.$config

export default [
  {
    path: '/',
    label: '',
    component: Layout,
    meta: { config: config },
    children: []
  },
  {
    label: 'notFound',
    path: '*',
    name: 'error',
    meta: { config: config },
    component: NotFound
  }
]



// WEBPACK FOOTER //
// ./src/router/map/async.js